// Fleet readout in the nav (DESIGN_SPEC §10.1): "■■■■□□□□ 4/8 slots free · 3 nodes" (plain text: there is no nodes page).
// Busy slots fill, free slots stay hollow (squares only up to 16 slots; past that the numbers speak).
// GET /v1/nodes lists only nodes with a fresh heartbeat, so every listed node counts. While the
// controller is unreachable the last answer stays, dimmed (.is-stale); the banner says why.
// Under 1100px it shortens to "4/8 free"; under 900px the nav hides it (components.css).
//   <FleetReadout />   polls through useNodes() every 5 s; renders nothing until the first answer
import { Slots } from "@/components/ui";
import { useNodes } from "@/hooks";

const MAX_SQUARES = 16;

export function FleetReadout() {
  const { data: nodes, isError } = useNodes();
  if (!nodes) return null;
  const cls = isError ? "fleet is-stale" : "fleet";

  if (nodes.length === 0) {
    return (
      <span className={cls}>no node online</span>
    );
  }

  const total = nodes.reduce((s, n) => s + Math.max(0, n.max_slots), 0);
  const free = nodes.reduce((s, n) => s + Math.min(Math.max(0, n.free_slots), Math.max(0, n.max_slots)), 0);
  const nodeWord = nodes.length === 1 ? "node" : "nodes";
  const slotWord = total === 1 ? "slot" : "slots";
  return (
    <span className={cls} title={`${free} of ${total} ${slotWord} free on ${nodes.length} ${nodeWord}`}>
      {total > 0 && total <= MAX_SQUARES && <Slots total={total} filled={total - free} />}
      <b>
        {free}/{total}
      </b>
      <span className="max-[1100px]:hidden">
        {slotWord} free · {nodes.length} {nodeWord}
      </span>
      <span className="min-[1100px]:hidden">free</span>
    </span>
  );
}
